import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { PersonalInformationRoutingModule } from './personal-information-routing.module';
import { PersonalInformationComponent } from './components/personal-information.component';
import { ReactiveFormsModule } from '@angular/forms';
import { TooltipModule } from 'ngx-bootstrap/tooltip';


@NgModule({
  imports: [
    CommonModule,
    PersonalInformationRoutingModule,
    ReactiveFormsModule,
    TooltipModule.forRoot(),
    TranslateModule.forChild()
  ],
  exports: [
    ReactiveFormsModule
  ],
  declarations: [PersonalInformationComponent]
})
export class PersonalInformationModule {
}
